/**
 * Offer-related selectors for SCI
 */

import type { CommonConsumer } from '@makemydeal/dr-platform-types';
import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';
import type { Consumer } from '@makemydeal/dr-shared-bff-types';

const getBuyerFromDeal = (state: any): Consumer | undefined =>
    state.salesCheckin?.activeDeal?.details?.dealStructure?.participants?.buyer;

const getCheckedInCustomer = (state: SalesCheckinRootState): CommonConsumer | undefined =>
    state.salesCheckin?.customer?.checkedInCustomer;

const mapBuyerToShopperInfo = (buyer: Consumer) => ({
    ...buyer,
    firstName: buyer.firstName,
    lastName: buyer.lastName,
    email: buyer.emailAddress,
    zip: buyer.address?.postalCode,
    phone: buyer.phoneNumber
});

const mapCustomerToShopperInfo = (customer: CommonConsumer | undefined) => ({
    ...customer,
    firstName: customer?.firstName,
    lastName: customer?.lastName,
    email: customer?.primaryEmail,
    zip: customer?.postalCode,
    phone: customer?.cellPhone
});

export const getHasBeenSent = (state: any): boolean => !!state.offerInfo?.hasBeenSent;

export const getIsOfferBeingSubmitted = (state: any): boolean => state.offerInfo?.isOfferBeingSubmitted;

export const getMonthlyPaymentRoundedByOfferType = (_state: any, _offerType: any): number => 299;

export const getCurrentOfferType = (_state: any): string => 'lease';

export const getShopperInfo = (state: any) => {
    const buyerInDeal = getBuyerFromDeal(state);
    const checkedInBuyer = getCheckedInCustomer(state);
    const shopperInfo: any = buyerInDeal ? mapBuyerToShopperInfo(buyerInDeal) : mapCustomerToShopperInfo(checkedInBuyer);

    shopperInfo.address = {
        addressLine1: buyerInDeal?.address?.addressLine1 ?? checkedInBuyer?.street1 ?? '',
        addressLine2: buyerInDeal?.address?.addressLine2 ?? checkedInBuyer?.street2 ?? '',
        addressLine3: buyerInDeal?.address?.addressLine3 ?? checkedInBuyer?.street3 ?? '',
        city: buyerInDeal?.address?.city ?? checkedInBuyer?.city ?? '',
        stateProvince: buyerInDeal?.address?.stateProvince ?? checkedInBuyer?.stateOrProvinceAbbreviation ?? '',
        country: buyerInDeal?.address?.country ?? checkedInBuyer?.countyOrRegion ?? '',
        postalCode: buyerInDeal?.address?.postalCode ?? checkedInBuyer?.postalCode ?? ''
    };

    return shopperInfo;
};

export const getShopperZip = (state: any): string | undefined => {
    return getShopperInfo(state).zip;
};

export const getOfferCreationDateString = (_state: any): string => '2025-08-01';

export const createGatewayOfferPayload = (_state: any, _offerUpdateType?: string) => {
    return {};
};

export const createOfferPayload = (_state: any, _offerUpdateType?: string) => {
    return {};
};

export const getOfferDealerSource = (_state: any): string => 'dealer';
